import { client } from ".";

async function fetchPage(page: number) {
	const { data } = await client.get<ResultList<Admin>>(`/admins`, {
		params: { page },
	});
	return data;
}

async function show(id: number) {
	const { data } = await client.get<Result<Admin>>(`/admins/${id}`);
	return data;
}

async function store(item: StoreAdmin) {
	const { data } = await client.post<Result<Admin>>("/admins", item);
	return data;
}

async function update(id: number, item: StoreAdmin) {
	const { data } = await client.put<Result<Admin>>(`/admins/${id}`, item);
	return data;
}

async function destroy(id: number) {
	const { data } = await client.delete(`/admins/${id}`);
	return data;
}

const adminsAPI = {
	fetchPage,
	show,
	store,
	update,
	destroy,
};

export default adminsAPI;
